import { z } from 'zod';
import { BaseFieldDefinitionSchema } from './base';
export var StringFieldDefinition;
(function (StringFieldDefinition) {
    StringFieldDefinition.TYPE = 'string';
})(StringFieldDefinition || (StringFieldDefinition = {}));
export const StringFieldDefinitionSchema = BaseFieldDefinitionSchema.and(z.object({
    type: z.literal(StringFieldDefinition.TYPE),
    defaultValue: z.string().optional(),
    i18n: z.boolean().optional(),
    validations: z
        .object({
        minLength: z.number().optional(),
        maxLength: z.number().optional(),
        pattern: z.string().optional()
    })
        .optional()
}));
export var BooleanFieldDefinition;
(function (BooleanFieldDefinition) {
    BooleanFieldDefinition.TYPE = 'boolean';
})(BooleanFieldDefinition || (BooleanFieldDefinition = {}));
export const BooleanFieldDefinitionSchema = BaseFieldDefinitionSchema.and(z.object({
    type: z.literal(BooleanFieldDefinition.TYPE),
    defaultValue: z.boolean().optional()
}));
export var NumberFieldDefinition;
(function (NumberFieldDefinition) {
    NumberFieldDefinition.TYPE = 'number';
})(NumberFieldDefinition || (NumberFieldDefinition = {}));
export const NumberFieldDefinitionSchema = BaseFieldDefinitionSchema.and(z.object({
    type: z.literal(NumberFieldDefinition.TYPE),
    defaultValue: z.number().optional(),
    validations: z
        .object({
        isInteger: z.boolean().optional(),
        min: z.number().optional(),
        max: z.number().optional()
    })
        .optional()
}));
export const PrimitiveFieldDefinitionSchema = StringFieldDefinitionSchema.or(BooleanFieldDefinitionSchema).or(NumberFieldDefinitionSchema);
//# sourceMappingURL=primitive.js.map